<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Video" class="d-icon d-icon--video" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3.003a.5.5 0 0 0-.5.5v4.994a.5.5 0 0 0 .5.5h5.502a.5.5 0 0 0 .5-.5V3.503a.5.5 0 0 0-.5-.5H2Zm7.002 1.252v-.752a1.5 1.5 0 0 0-1.5-1.5H2a1.5 1.5 0 0 0-1.5 1.5v4.994a1.5 1.5 0 0 0 1.5 1.5h5.502a1.5 1.5 0 0 0 1.5-1.5v-.765l1.812.726a.5.5 0 0 0 .686-.465v-4a.5.5 0 0 0-.686-.464l-1.812.726Zm0 1.077v1.323l1.498.6V4.732l-1.498.6Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconVideo',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
